import { render } from "./PayIcon.vue?vue&type=template&id=77690754"
import script from "./PayIcon.vue?vue&type=script&lang=js"
export * from "./PayIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__